import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { IOperacoesPatioEntradaSaidaVeiculosSPE } from "../types/types";

interface Props {
  data?: IOperacoesPatioEntradaSaidaVeiculosSPE;
  title: string;
  onClose: () => void;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data/Hora Entrada
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_hora ? formatDateTimeBR(props.data.data_hora) : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Placa Dianteira
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.placa_dianteira ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Placa Traseira
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.placa_traseira ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Cancela Entrada
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.cancela?.numero_cancela ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data/Hora Saída
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.saida?.data_hora ? formatDateTimeBR(props.data.saida.data_hora) : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Cancela Saída
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.saida?.cancela?.numero_cancela ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Identificadores Contêineres
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.identificadores_conteineres ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Usuário Responsável
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ?? '---'}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
